// extracted by mini-css-extract-plugin
module.exports = {"container":"YearInvestorEvents_container__2ahw4","content":"YearInvestorEvents_content__1DjUK","empty":"YearInvestorEvents_empty__20kqh"};